import React from "react"

const PoiIcon = () => {
  return (
    <svg width="39" height="35" viewBox="0 0 39 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.8104 21.3585C22.1789 21.628 22.8884 21.7875 23.2569 21.793C23.8729 21.7985 24.4339 21.6995 25.0059 21.2815C25.6659 20.7975 26.1719 19.912 26.2709 19.285C26.5129 17.7725 26.1499 16.678 25.3139 15.534C24.7089 14.709 23.8784 14.0325 23.0094 13.708C20.6554 12.828 18.2409 13.1635 16.1949 14.6595C15.3864 15.2535 14.6164 16.1445 14.1104 17.0025C12.4164 19.8735 12.4659 23.9435 14.7539 27.073C15.1059 27.557 15.5679 28.096 16.0134 28.5195C19.9184 32.21 26.0839 32.5455 30.7314 29.1465C32.5354 27.8265 34.1524 25.6485 34.8014 24.257C37.0949 19.3345 36.4404 13.9225 33.2284 9.52246C30.9679 6.43146 27.4314 4.45146 24.2634 3.73646C19.5829 2.70246 14.5009 3.60446 10.3319 6.65146C7.02637 9.07146 4.94187 12.3385 3.80337 16.0235C2.42287 20.495 2.65937 26.589 5.79437 31.264C5.97587 31.539 6.34987 31.5995 6.61387 31.4015L13.9564 25.918"
        stroke="url(#paint0_linear_199_39018)"
        strokeWidth="5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.717 21C22.717 21 20.9625 22.672 21.3695 25.301C21.7765 27.9245 20 29.668 20 29.668"
        stroke="url(#paint1_linear_199_39018)"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M25.9741 19.7305C25.9741 19.7305 26.9256 21.958 29.5326 22.497C32.1341 23.0305 33.1461 25.3075 33.1461 25.3075"
        stroke="url(#paint2_linear_199_39018)"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M26 14.9865C26 14.9865 28.5765 15.2438 30.4644 13.5106C32.3582 11.7774 35 12.0105 35 12.0105"
        stroke="url(#paint3_linear_199_39018)"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M22 13C22 13 23.6369 10.9507 22.9919 8.04207C22.3523 5.13341 24 3 24 3"
        stroke="url(#paint4_linear_199_39018)"
        strokeWidth="3"
        strokeMiterlimit="10"/>
      <path
        d="M15.832 13.5982C15.832 13.5982 15.7605 11.0957 13.467 9.59966C11.168 8.09816 11.0635 5.53516 11.0635 5.53516"
        stroke="url(#paint5_linear_199_39018)"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M12.8893 18.702C12.8893 18.702 10.9643 17.129 8.3518 17.877C5.7393 18.625 3.7373 17.041 3.7373 17.041"
        stroke="url(#paint6_linear_199_39018)"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient id="paint0_linear_199_39018" x1="19.5818" y1="3.32617" x2="19.5818" y2="31.5178" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0960A3"/>
          <stop offset="1" stopColor="#03243D"/>
        </linearGradient>
        <linearGradient id="paint1_linear_199_39018" x1="22.5" y1="21" x2="20.5" y2="29.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#063C65"/>
          <stop offset="1" stopColor="#042845"/>
        </linearGradient>
        <linearGradient id="paint2_linear_199_39018" x1="33.5" y1="25.5" x2="26" y2="19.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#05365C"/>
          <stop offset="1" stopColor="#063E6A"/>
        </linearGradient>
        <linearGradient id="paint3_linear_199_39018" x1="34.2773" y1="11.6914" x2="26.8405" y2="15.9352" gradientUnits="userSpaceOnUse">
          <stop stopColor="#074F86"/>
          <stop offset="1" stopColor="#074678"/>
        </linearGradient>
        <linearGradient id="paint4_linear_199_39018" x1="23" y1="3" x2="23.1844" y2="13.3796" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0960A3"/>
          <stop offset="1" stopColor="#074C81"/>
        </linearGradient>
        <linearGradient id="paint5_linear_199_39018" x1="13.4477" y1="5.53516" x2="13.4477" y2="13.5982" gradientUnits="userSpaceOnUse">
          <stop stopColor="#095C9D"/>
          <stop offset="1" stopColor="#074D82"/>
        </linearGradient>
        <linearGradient id="paint6_linear_199_39018" x1="3.7373" y1="17.8715" x2="12.8893" y2="17.8715" gradientUnits="userSpaceOnUse">
          <stop stopColor="#064575"/>
          <stop offset="1" stopColor="#063F6B"/>
        </linearGradient>
      </defs>
    </svg>
  )
}

export default PoiIcon
